module.exports = __webpack_public_path__ + "img/10996_DENIMAX.dd55928c.webp";